import SiteRequirements from "./SiteRequirements";

export default SiteRequirements;